import React, { FC, Fragment, useState } from 'react';
import { useQuery } from '@apollo/client';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';
import { meditStatusVar } from 'apollo/reactive-variables/scan-case';
import { Alert, Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from 'config/constants';
import { meditStatusTemplate } from 'apollo/templates/scanner-case';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';
import { ScannerCaseAuthStatus } from 'models/scanner-case';

const MeditAuthContainer: FC = () => {
    const { t: translate } = useTranslation(['scan-cases']);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [meditAuthUrl, setMeditAuthUrl] = useState('');
    const meditFrontendStatus = meditStatusVar();
    const { showBoundary } = useDenthubErrorBoundary();
    const isCurrentlyAuthorizing = window.location.href.includes('medit-auth-callback');

    useQuery(meditStatusTemplate, {
        onError: (error) => {
            showBoundary(error);
        },
        onCompleted: ({ meditStatus }: { meditStatus: ScannerCaseAuthStatus }) => {
            meditStatusVar(meditStatus);
            if (meditStatus.enabled && !meditStatus.authorized && !isCurrentlyAuthorizing) {
                setDialogOpen(true);
                setMeditAuthUrl(
                    `${CONSTANTS.MEDIT_AUTH_URL}/oauth/authorize?client_id=${meditStatus.clientId}&response_type=code&redirect_uri=${CONSTANTS.MEDIT_AUTH_REDIRECT}&scope=${CONSTANTS.MEDIT_SCOPE}&state=${meditStatus.state}`,
                );
            }
        },
    });

    const onDialogClose = () => {
        setDialogOpen(false);
    };

    return (
        <Fragment>
            {meditFrontendStatus.enabled ? (
                <DHDialog
                    fullWidth
                    maxWidth="sm"
                    open={dialogOpen}
                    onClose={onDialogClose}
                    title={translate('scan-cases:YOU_NEED_TO_LOGIN_TO_MEDIT')}
                >
                    <Alert severity="info" sx={{ whiteSpace: 'pre-wrap' }}>
                        {translate('scan-cases:MEDIT_LOGIN_DESC')}
                    </Alert>
                    <Box mt={2} sx={{ textAlign: 'center' }}>
                        <Button variant="contained" href={meditAuthUrl}>
                            {translate('scan-cases:LOGIN_TO_MEDIT')}
                        </Button>
                    </Box>
                </DHDialog>
            ) : undefined}
        </Fragment>
    );
};

export default MeditAuthContainer;
